/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_us_validation_birth_date_required = /** @type {(inputs: {}) => string} */ () => {
	return `La fecha de nacimiento es requerida`
};

const en_accounts_us_validation_birth_date_required = /** @type {(inputs: {}) => string} */ () => {
	return `Birth date is required`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_us_validation_birth_date_required = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_us_validation_birth_date_required(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_us_validation_birth_date_required", locale)
	if (locale === "es") return es_accounts_us_validation_birth_date_required(inputs)
	return en_accounts_us_validation_birth_date_required(inputs)
};
export { accounts_us_validation_birth_date_required as "accounts.us.validation.birth_date_required" }